module.exports = __webpack_public_path__ + "img/zifen.d0f61b7a.png";